export interface Goal {
    id: string;
    name: string;
}

export interface GoalDecl {
    title: string;
    key: string;
    hidden?: boolean;
}

export interface GoalStats {
    conversionRate: number;
    costPerAction: number;
    goalId: string;
    goals: number;
}

export enum AdditionalGoalIds {
    notSet = 'notSet',
    all = 'all'
}
